import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSuggestionsComponent',
  emits: ['suggestion-selected'],
  setup(__props, { emit }) {

const { t } = useI18n()



const TEXT = {
  title: t('components.search_advance_ia.more_suggestions')
}

const SUGGESTIONS = [
  '¿Hay plazos o fechas clave que vencen?',
  'Dame toda la información sobre las costas',
  '¿Qué recursos se han interpuesto en este expediente?',
  '¿Qué argumentos tiene la parte contraria?'
]

const handleClick = (suggestion: string) => {
  emit('suggestion-selected', suggestion)
}

return { __sfc: true,t, emit, TEXT, SUGGESTIONS, handleClick }
}

})